"use client";

import { ReactNode, useState } from "react";
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";
import { WheelGesturesPlugin } from "embla-carousel-wheel-gestures";
import { cn } from "@/lib/utils";
import { SliderWrapper } from "@/components/common/slider-wrapper";

export const CardSlider = ({
  items,
  className = "@container my-6",
  basis = "basis-[328px] md:basis-[400px]",
  alwaysToLeft = false,
  carouselContentClassName = "",
  setApi: externalSetApi,
}: {
  items: ReactNode[];
  className?: string;
  basis?: "basis-[280px] md:basis-[300px]" | "basis-[280px]" | string;
  alwaysToLeft?: boolean;
  carouselContentClassName?: string;
  setApi?: (api: CarouselApi) => void;
}) => {
  const [api, setApi] = useState<CarouselApi | null>(null);

  const handleSetApi = (newApi: CarouselApi) => {
    setApi(newApi);
    if (externalSetApi) {
      externalSetApi(newApi);
    }
  };

  return (
    <div className={className}>
      <div
        className={cn(
          "sm:overflow-hidden @min-[700px]:mx-auto",
          alwaysToLeft && "@min-[700px]:mx-0",
        )}
      >
        <SliderWrapper api={api}>
          <Carousel
            opts={{
              skipSnaps: true,
            }}
            setApi={handleSetApi}
            plugins={[WheelGesturesPlugin()]}
          >
            <CarouselContent className={carouselContentClassName}>
              {items.map((item, index) => (
                <CarouselItem
                  className={cn(basis)}
                  isFirst={index === 0}
                  key={index}
                  isLast={index === items.length - 1}
                >
                  {item}
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </SliderWrapper>
      </div>
    </div>
  );
};
